import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { Control } from 'react-hook-form';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Button } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import AiIdentifyPics, { AiIdentifyPicsRef } from './ai-identify-pics';
import StoreReceiptPicsUploader from './store-receipt-pics-uploader';
import BindAuthenticationResultModal, {
  TaskItem,
} from '../bind-authentication-result-modal';

const StoreReceiptPics = ({
  control,
  index,
  bagTypeName,
  isBKC,
  fieldId,
  onAiIdentifyRefChange,
  onBindSelect,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  bagTypeName?: string;
  isBKC: boolean;
  fieldId: string;
  onAiIdentifyRefChange?: (
    fieldId: string,
    ref: AiIdentifyPicsRef | null,
  ) => void;
  onBindSelect: (item: TaskItem) => void | Promise<void>;
}) => {
  const [bindModalOpen, setBindModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'default' | 'ai'>(
    isBKC ? 'ai' : 'default',
  );

  const handleTabChange = useCallback(
    (tab: 'default' | 'ai') => {
      if (tab === activeTab) return;
      setActiveTab(tab);
    },
    [activeTab],
  );

  // 切换包款时，BKC 包款默认切到 AI 鉴定，非 BKC 切回默认
  useEffect(() => {
    const targetTab = isBKC ? 'ai' : 'default';
    handleTabChange(targetTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBKC]);

  const handleAiIdentifyRefChange = useCallback(
    (ref: AiIdentifyPicsRef | null) => {
      onAiIdentifyRefChange?.(fieldId, ref);
    },
    [fieldId, onAiIdentifyRefChange],
  );

  return (
    <div className="flex items-start gap-2">
      <BindAuthenticationResultModal
        open={bindModalOpen}
        onClose={() => setBindModalOpen(false)}
        onSelect={onBindSelect}
      />
      <FormLabel className="self-start">
        {i18n.t(LOCALS.product_photos)}:
      </FormLabel>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2">
          <Button
            size="small"
            type={activeTab === 'default' ? 'primary' : 'default'}
            onClick={() => handleTabChange('default')}
          >
            {i18n.t(LOCALS.default_tab)}
          </Button>
          <Button
            size="small"
            type={activeTab === 'ai' ? 'primary' : 'default'}
            onClick={() => handleTabChange('ai')}
          >
            {i18n.t(LOCALS.ai_identify)}
          </Button>
          <Button
            size="small"
            type="dashed"
            onClick={() => setBindModalOpen(true)}
          >
            {i18n.t(LOCALS.bind_authentication_result)}
          </Button>
        </div>

        <div className={activeTab === 'default' ? '' : 'hidden'}>
          <StoreReceiptPicsUploader control={control} index={index} />
        </div>

        <div className={activeTab === 'ai' ? '' : 'hidden'}>
          <AiIdentifyPics
            ref={handleAiIdentifyRefChange}
            control={control}
            index={index}
            bagTypeName={bagTypeName}
          />
        </div>
      </div>
    </div>
  );
};

export default StoreReceiptPics;
